import React, { Component } from 'react'
import {Link} from 'react-router';
import moment from 'moment';
import TextTruncate from 'react-text-truncate';

export default class RowItemDSThongBao extends Component {

  render() {
    const {count} = this.props;
    const {content, ngayTao} = this.props.item
    const phanHe = this.props.item.type === "TB_THANH_TRA" ? 'Thanh tra' : '';
    return (
      <tr>
        <td>{count}</td>
        <td>{moment(ngayTao).format('DD/MM/YYYY')}</td>
        <td>
          <TextTruncate
            line={1}
            truncateText="…"
            text={content}
          />
        </td>
        <td>{phanHe}</td>
        <td>
        <div className="wrap-link-todo">
          <Link to={`/thanh-tra/chi-tiet-thong-bao/${this.props.item.thongBaoId}`}><span className="tt-xem-chi-tiet"></span>Chi tiết</Link>
        </div>
        </td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/datatable/RowItemDSThongBao.jsx